import React, { useState } from 'react'

// JSON data
import ListOfProjects from './Project/projects.json'
import ItemsToFilter from './Filters/Filters.json'

// Other components
import Filters from './Filters/Filters'
import Project from './Project/Project'

const Projects = () => {
  const [projects, setProjects] = useState(ListOfProjects);

  const filterProjects = (filter) => {
    let list = ListOfProjects,
      filters = ItemsToFilter,
      filteredProjects = [];

    if (filter === '*') {
      filteredProjects = list;
    } else {
      filteredProjects = list.filter((item) => item.filter === filter);
    }

    filters.forEach((item) => {
      item.isActive = item.filter === filter;
    });

    setProjects(filteredProjects);
  };

  return (
    <div className="section" id="projects">
      <div className="container">
        <div className="col-md-12">
          <h4>03</h4>
          <h1 className="size-50">
            My <br />
            Projects
          </h1>
        </div>

        <div className="main-container portfolio-inner clearfix">
          <div className="portfolio-div">
            <div className="categories-grid wow fadeInLeft">
              <Filters filters={ItemsToFilter} filterProjects={filterProjects} />
              <Project projects={projects} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
